import React from "react";

function Success() {
  return (
    <div>
      <article>
        <p>Thank you for your purchase :)</p>
        <p>Your order has been successfully processed.</p>
        <p>If you have any questions you can email us at felix@pedra.ai</p>
      </article>
    </div>
  );
}

export default Success;
